var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgConnectorTemplate = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M15.813 11.007a4.8 4.8 0 0 0-2.874.956L10.037 9.06A4.7 4.7 0 0 0 11 6.194a4.812 4.812 0 1 0-1.932 3.843l2.895 2.902a4.812 4.812 0 1 0 3.85-1.932M2.75 6.194a3.437 3.437 0 1 1 6.875 0 3.437 3.437 0 0 1-6.875 0",
  clipRule: "evenodd"
})));
export default SvgConnectorTemplate;